import { render, staticRenderFns } from "./PatientBuildingSection.vue?vue&type=template&id=12f0c4fa&"
import script from "./PatientBuildingSection.vue?vue&type=script&lang=js&"
export * from "./PatientBuildingSection.vue?vue&type=script&lang=js&"
import style0 from "./PatientBuildingSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports